import React from "react";
import "./style.css";
import CPReviewContainer from "./CPReviewContainer";

function CPReviewsMain({ productDetail, productId, setCurrentTab }) {
  return (
    <div className="ob-pi-form-container cp-ps-main-container">
      <h3 className="ob-supplier-content-heading m-0">Product review</h3>
      <p className="cp-form-description mt-2 mb-4">
        Summary of product that you have just added, review and go back to any
        step for updating
      </p>
      <CPReviewContainer
        productDetail={productDetail?.data}
        productId={productId}
        setCurrentTab={setCurrentTab}
      />
    </div>
  );
}

export default CPReviewsMain;
